import {
  EVENT_FORM_SUBMITTED,
  MAIN_NAV_TRACK,
  SHOPPING_PREFERENCES_GA_TRACK_ATTRIBUTES
} from 'constants/analyticsConstants';

export const CUSTOMER_TYPE_IA = 'IA';
export const CUSTOMER_TYPE_CSP = 'CSP';
export const MAX_FULFILLMENT_INST_LEN = 150;
export const FULFILLMENT_INST_ROW_LEN = 3;
export const SECTION_LOGIN = 'Login';
export const FULFILLMENT_TYPE_PICKUP = 'pickup';
export const FULFILLMENT_TYPE_DELIVERY = 'delivery';
export const FULFILLMENT_TYPE_DROPBOX = 'dropBox';
export const FULFILLMENT_TYPE_SHOP_ONLINE = 'shopOnline';
export const PO_NUMBER_REGEX = /[<>]/;
export const MAX_LENGTH_PO_NUMBER = 20;
export const SAVE_PREFERENCES_BUTTON_STICKY_CONTAINER =
  'save-preferences-button-sticky-container';

export enum ErrorType {
  REGISTRATION_PENDING_APPROVAL = 'pendingApproval',
  SHOPPING_PREFERENCES_ERROR = 'getPreferences'
}

export const gaInfo = {
  event: EVENT_FORM_SUBMITTED,
  formName: MAIN_NAV_TRACK.SHOPPING_PREFERENCES_TEXT,
  pagePath: null,
  formStatus: null,
  formAdditionalContent: null,
  formFieldCausingError: null,
  formContent: null,
  formContent2: null,
  formLocation: SHOPPING_PREFERENCES_GA_TRACK_ATTRIBUTES.FORM_LOCATION
};

export const gaCspInfo = {
  ...gaInfo,
  formName: SHOPPING_PREFERENCES_GA_TRACK_ATTRIBUTES.CSP_FORM_NAME
};
